import React from 'react';
import { css } from '@emotion/css';
import appLabels from '../../utils/appLabels';
import { isMobile } from '../../utils/utils';

const titleStyle = css`
  font-weight: 600;
  font-size: 1.75rem;
  line-height: 2.125rem;
  color: #2a2928;
`;

const subtitleStyle = css`
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1rem;
  color: #2a2928;
  margin-top: 2.625rem;
`;

const detailStyle = css`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  color: #2a2928;
  margin-top: 1rem;
`;

const LinkStyle = css`
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.5rem;
  color: #7b1a27;
  margin-top: 1rem;
  text-decoration-line: underline;
`;

const UserWithoutSubscription = () => {
  const analyticsEvents = (linkType) => {
    try {
      if (window['AB']?.DATALAYER) {
        if (linkType === 'shopLink') {
          window['AB']?.DATALAYER.analyticsCTATracking(
            'cta:upcoming-orders-never-enrolled|link|shop-now-schedule-and-save',
          );
        } else if (linkType === 'aboutLink') {
          window['AB']?.DATALAYER.analyticsCTATracking(
            'cta:upcoming-orders-never-enrolled|link|learn-more-schedule-and-save',
          );
        }
      }
    } catch (error) {
      // Handle any errors that occur during execution
      console.error('@AnalyticsTeam error:', error);
    }
  };

  return (
    <div>
      <div className={titleStyle}>Schedule & Save</div>
      <div className={subtitleStyle}>{appLabels.UserWithoutSubscription.headLine}</div>
      <div className={detailStyle}>{appLabels.UserWithoutSubscription.description}</div>
      <a onClick={() => analyticsEvents('aboutLink')} href={appLabels.UserWithoutSubscription.aboutLink}>
        <div className={LinkStyle}>{appLabels.UserWithoutSubscription.ctaText}</div>
      </a>
      {isMobile() ? null : (
        <a onClick={() => analyticsEvents('shopLink')} href={appLabels.UserWithoutSubscription.shopLink}>
          <div className={LinkStyle}>{appLabels.UserWithoutSubscription.ctaTitle}</div>
        </a>
      )}
    </div>
  );
};

export default UserWithoutSubscription;
